module.exports = __webpack_public_path__ + "static/media/IMG_20180316_221752.95065078.webp";